import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TemplateComponent from "../TemplateComponent";
import NewTemplates from "../TemplateComponent/NewTemplates";

function TemplateModal({ open, close, setInputValue }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    overflow: "hidden",
    scrollbarWidth: "none",
    maxHeight: "90vw",
    width: window.innerWidth > 1200 ? "40%" : "90%",
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={style}>
          <NewTemplates close={close} setInputValue={setInputValue} />
          {/* <TemplateComponent close={close} /> */}
        </Box>
      </Modal>
    </div>
  );
}

export default TemplateModal;
